<template> 
  <div id="action" class="action">
  <p style="color:red;text-align:center">{{ errorMessage }}</p>
  <loading :active.sync="isLoading" 
                :can-cancel="true" 
                :is-full-page="fullPage"></loading>
      <button class="badge badge-info" @click="invoiceDetail()"><i class="material-icons">remove_red_eye</i></button> 
      <button v-if="row.transfer_status !== 'paid' && row.status !== 'released'" class="badge badge-secondry editBtn" id="editBtn tranferEdit" v-on:click="editInvoice()"><i class="material-icons">edit</i></button>
      <!-- <button v-if="row.status === 'open'" class="badge badge-secondry editBtn" id="editBtn" v-on:click="editInvoice()"><i class="material-icons">edit</i></button> -->
      <button class="badge badge-danger" v-if="row.status === 'draft'" v-confirm="{ loader: false, ok: deleteInvoice, message: 'Do you really want to delete?'}"><i class="material-icons">delete</i></button>
      <!--<button class="btn btn-primary" id="transfer" v-if="row.status === 'paid' && row.invoice_type === 'held' &&  row.manual_payment && row.manual_payment ===''" v-on:click="transfer()">Approve</button> -->
     <button class="btn btn-primary" id="transfer" v-if="row.status === 'paid' && row.invoice_type === 'held' && row.manual_payment ===''" v-confirm="{ loader: false, ok: transfer, message: 'Do you really want to release?'}">Approve</button>
     <button class="btn"><i class="fas fa-file-pdf" v-on:click="download()"></i></button>
  </div>
</template>
<script>
  import axios from 'axios'
  import moment from 'moment'
  import Invoice from './Invoice'
  import EditInvoiceModal from './EditInvoiceModal.vue'
  import Loading from 'vue-loading-overlay'
  import 'vue-loading-overlay/dist/vue-loading.css'
  export default {
    name: 'brandAction',
    props: ['row', 'data'],
    components: {Invoice,
      Loading
    },
    data () {
      return {
        isLoading: false,
        fullPage: true,
        errorMessage: '',
        date: '2019-10-01 00:00:00',
        invoicesList: [],
        invoices: [],
        realtime: '',
        brands: [],
        users: [],
        invoiceDatas: [],
        invoicePartiesPercentageDatas: [],
        BrandDatas: [],
        errors: [],
        i: 0,
        invoiceDetails: {
          InvoiceData: {
            amount: '',
            description: '',
            uid: '',
            invoice_percentage_id: '',
            brand_id: ''
          },
          invoicePercentageData: {
            admin_percentage: '',
            userA_percentage: '',
            userB_percentage: '',
            admin_id: '',
            userA_id: '',
            userB_id: ''
          }
        },
        selectedBrand: '',
        selecteduserA: '',
        selecteduserB: '',
        selectedDays: '',
        statusInvoice: ''
      }
    },
    methods: {
      deleteInvoice () {
        var jwttoken = localStorage.getItem('jwt')
          let uid = this.row.uid
          this.isLoading = true
          axios.delete('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/deleteInvoice' + '?' + 'uid' + '=' + uid, {
            headers: {
              'x-access-token': jwttoken
            }})
            .then(response => {
               this.isLoading = false
               this.$eventBus.$emit('listInvoice', 'Invoice is deleted successfully');
               this.$eventBus.$emit('latestDashbordList');
            }).catch(function(error) {
               this.isLoading = false
               this.$eventBus.$emit('listInvoice', '','Invoice could not be deleted');
              });
      },
      transfer () {
        this.isLoading = true
        var jwttoken = localStorage.getItem('jwt')
        var uid = this.row.uid
        axios.post('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/transferPayouts',
          {
            invoice_id: uid
          }, {
            headers: {
              'x-access-token': jwttoken
            }})
          .then(response => {
            this.isLoading = false
            if ( response.data.message.adminData.adminStatus && 
               ( response.data.message.userAData.userAStatus || 
                response.data.message.userBData.userBStatus)
               ) {
                   let str= ''
                    if (response.data.message.userAData.userAStatus) {
                        str +=  `${response.data.message.userAData.userAMessage}\n`
                    }
                    if (response.data.message.userBData.userBStatus) {
                        str +=  `${response.data.message.userBData.userBMessage}\n`
                    }
                    if (response.data.message.userCData.userCStatus) {
                        str +=  `${response.data.message.userCData.userCMessage}\n`
                    }
                    if (response.data.message.adminData.adminStatus) {
                        str +=  `${response.data.message.adminData.adminMessage}\n` 
                    }
                  
                  
                   this.$eventBus.$emit('listInvoice', str);
             
             } else {
              
                   let str= ''
                    if (!response.data.message.userAData.userAStatus) {
                        str +=  `${response.data.message.userAData.userAMessage}\n`
                    }
                    if (!response.data.message.userBData.userBStatus) {
                        str +=  `${response.data.message.userBData.userBMessage}\n`
                    }
                    if (!response.data.message.userCData.userCStatus) {
                        str +=  `${response.data.message.userCData.userCMessage}\n`
                    }
                    if (!response.data.message.adminData.adminStatus) {
                        str +=  `${response.data.message.adminData.adminMessage}\n` 
                    }
               //   var errorMessage = response.data.message.userAData.userAMessage + ',' + response.data.message.userBData.userBMessage
                this.$eventBus.$emit('listInvoice', false ,str,10000); // this.$router.replace('/Invoice?errorMessage=' + errorMessage)

            }
          })
          .catch((error) => {
            this.errorMessage = error.response.data.errors
            this.isLoading = false
          })
      },
      invoiceDetail () {
        let location = '/invoiceDetail' + '/' + this.row.uid + '/' + 'invoicelistpage'
        this.$router.push(location);
      },
      editInvoice () {
        var jwttoken = localStorage.getItem('jwt')
        let uid = this.row.uid
        let status = this.row.status
        this.isLoading = true
        axios.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getInvoiceById' + '?' + 'invoice_id' + '=' + uid, {
          headers: {
            'x-access-token': jwttoken
          }})
          .then(response => {
            this.isLoading = false
            this.invoiceDetails = response.data.results
            this.statusInvoice = status
            var timestamap = response.data.results.InvoiceData.schedule_date
            this.realtime = moment(timestamap).format('YYYY-MM-DD hh:mm:ss')
            this.invoiceDetails.InvoiceData.schedule_date = this.realtime
            this.$modal.show(EditInvoiceModal, { invoiceDetails: response.data.results }, { height: '100%' })
          })
          .catch((error) => {
            // console.log(error.response.data.errors)
            this.errorMessage = error.response.data.errors
            this.isLoading = false
          })
      },
      download () {
        //alert('1')
        var jwttoken = localStorage.getItem('jwt')
        let uid = this.row.uid
        this.isLoading = true
        axios.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/pdfCreator' + '?' + 'invoice_id' + '=' + uid, {
          headers: {
            'x-access-token': jwttoken
          }})
          .then(response => {
            this.isLoading = false
            var url = response.data.results
            window.open(url)
            this.isLoading = false
          })
          .catch((error) => {
            // console.log(error.response.data.errors)
            this.errorMessage = error.response.data.errors
            this.isLoading = false
          })
      }
    },
    mounted () {
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/invoiceAction.vue